class Announcement extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 0;
    this.slideTimer = null;
    this.slideInterval = 4000;
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.sliderItem = this.getElementsByClassName("announcement-inner");
    this.slideCount = this.sliderItem.length;

    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    this.mqMobile = window.matchMedia("(max-width: 880px)");

    window.addEventListener("resize", this.onResize);

    if (this.mqMobile.matches && this.slideCount > 0) {
      this.showSlide(this.currentSlide);
    } else {
      [...this.sliderItem].forEach((slide) =>
        slide.removeAttribute("aria-hidden")
      );
    }

    this.syncAutoplay();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
    this.stopAutoplay();
  }

  onResize() {
    if (this.mqMobile.matches && this.slideCount > 0) {
      this.showSlide(this.currentSlide);
    } else {
      [...this.sliderItem].forEach((slide) =>
        slide.removeAttribute("aria-hidden")
      );
    }
    this.syncAutoplay();
  }

  syncAutoplay() {
    this.stopAutoplay();
    if (
      this.mqMobile.matches &&
      this.slideCount > 1 &&
      !this.reducedMotion.matches
    ) {
      this.startAutoplay();
    }
  }

  startAutoplay() {
    this.slideTimer = setInterval(() => {
      this.nextSlide();
    }, this.slideInterval);
  }

  stopAutoplay() {
    if (this.slideTimer) {
      clearInterval(this.slideTimer);
      this.slideTimer = null;
    }
  }

  nextSlide() {
    if (this.slideCount < 2) return;
    this.currentSlide = (this.currentSlide + 1) % this.slideCount;
    this.showSlide(this.currentSlide);
  }

  showSlide(slideIndex) {
    const slidesArray = [...this.sliderItem];
    const mobile = this.mqMobile.matches;
    slidesArray.forEach((slide, index) => {
      const isActive = index === slideIndex;
      if (mobile) {
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      } else {
        slide.removeAttribute("aria-hidden");
      }
      if (isActive) {
        slide.classList.add("active");
        slide.style.transform = "translateX(0%)";
      } else {
        slide.classList.remove("active");
        slide.style.transform = "translateX(100%)";
      }
    });
  }
}
customElements.define("announcement-bar", Announcement);

class MarqueeText extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const scrollingSpeed = parseInt(
          this.getAttribute("scrolling-speed") || 5
        ),
        contentWidth = this.offsetWidth,
        slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);
      this.style.setProperty(
        "--marquee-animation-duration",
        `${(
          (scrollingSpeed *
            slowFactor *
            this.querySelector("span").clientWidth) /
          contentWidth
        ).toFixed(3)}s`
      );
    }
}
customElements.define("marquee-text", MarqueeText);

class VideoReviews extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        const selectorId = this.dataset.selector;
        const swiperConfig = {
                loop: false,
                arrows: false,
                autoplay: false,
                spaceBetween: 20,
                watchOverflow: false,
                breakpoints: {
                    320:{
                        slidesPerView: 1.6,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 1
                    },
                    800: {
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                      spaceBetween: 20,
                    },
                    1360: {
                        slidesPerView: 5,
                        slidesPerGroup: 1
                    }
                },
                scrollbar: {
                    el: '#swiper-' + selectorId + ' .video-reviews-scrollbar-' + selectorId,
                    draggable: true,
                    hide: false,
                    dragSize: 'auto',
                },
                navigation: {
                    nextEl: '.swiper-button-next-'+selectorId,
				    prevEl: '.swiper-button-prev-'+selectorId,
                }
            }

        new Swiper( '#swiper-'+selectorId, swiperConfig );

        this.querySelectorAll('.review-author').forEach((author) => {
          author.addEventListener('click', function () {
            this.querySelector('[data-review-content]')?.classList.toggle('hidden');
          });
        });
    }
}
customElements.define( 'video-reviews',  VideoReviews );

class CardsSliderSection extends HTMLElement {
    connectedCallback() {
        const selectorId = this.dataset.selector;
        const swiperElement = document.querySelector('#swiper-' + selectorId);

        if (!swiperElement || typeof Swiper === 'undefined') {
            return;
        }

        new Swiper('#swiper-' + selectorId, {
            loop: false,
            arrows: false,
            autoplay: false,
            autoHeight: true,
            watchOverflow: true,
            slidesPerView: 1.1,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 2.6,
                    spaceBetween: 20,
                },
            },
            pagination: {
                el: '.swiper-pagination-' + selectorId,
                type: 'progressbar',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-' + selectorId,
                prevEl: '.swiper-button-prev-' + selectorId,
            },
        });
    }
}
customElements.define('cards-slider-section', CardsSliderSection);

class ProductTabsBordeaux extends HTMLElement {
    connectedCallback() {
        const tabs = this.querySelectorAll('[data-product-tab]');
        const panels = this.querySelectorAll('[data-product-panel]');

        const activate = (index) => {
            tabs.forEach((tab, j) => {
                const on = j === index;
                tab.classList.toggle('is-active', on);
                tab.setAttribute('aria-selected', on ? 'true' : 'false');
                tab.setAttribute('tabindex', on ? '0' : '-1');
                if (panels[j]) {
                    if (on) {
                        panels[j].removeAttribute('hidden');
                    } else {
                        panels[j].setAttribute('hidden', '');
                    }
                }
            });
        };

        tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => activate(i));
        });

        this.querySelectorAll('.product-tabs-bordeaux__mobile details').forEach((detailsEl) => {
            detailsEl.addEventListener('toggle', () => {
                if (!detailsEl.open) return;
                this.querySelectorAll('.product-tabs-bordeaux__mobile details').forEach((other) => {
                    if (other !== detailsEl) {
                        other.removeAttribute('open');
                    }
                });
            });
        });
    }
}
customElements.define('product-tabs-bordeaux', ProductTabsBordeaux);

class ProductFeaturesShowcase extends HTMLElement {
  connectedCallback() {
    this._readMoreAbort?.abort();
    this._readMoreAbort = new AbortController();
    const readMoreSignal = this._readMoreAbort.signal;
    this.querySelectorAll('.product-showcase__read-more').forEach((button) => {
      button.addEventListener(
        'click',
        (event) => {
          event.stopPropagation();
          ProductFeaturesShowcase.toggleReadMore(button);
        },
        { signal: readMoreSignal }
      );
    });

    const selectorId = this.dataset.selector;
    const swiperRoot = this.querySelector('#swiper-' + selectorId);
    if (!swiperRoot) return;
    if (swiperRoot.swiper) {
      swiperRoot.swiper.destroy(true, true);
    }
    const scrollbarEl = this.querySelector('.product-showcase-scrollbar-' + selectorId);
    const prevEl = this.querySelector('.product-showcase__nav-prev');
    const nextEl = this.querySelector('.product-showcase__nav-next');

    const swiperConfig = {
      loop: false,
      spaceBetween: 24,
      slidesPerView: 1,
      watchOverflow: true,
    };
    if (scrollbarEl) {
      swiperConfig.scrollbar = {
        el: scrollbarEl,
        draggable: true,
        hide: false,
        dragSize: 'auto',
      };
    }
    if (prevEl && nextEl) {
      swiperConfig.navigation = {
        prevEl,
        nextEl,
      };
    }
    new Swiper(swiperRoot, swiperConfig);
  }

  disconnectedCallback() {
    this._readMoreAbort?.abort();
    this._readMoreAbort = null;
    const selectorId = this.dataset.selector;
    const swiperRoot = this.querySelector('#swiper-' + selectorId);
    if (swiperRoot?.swiper) {
      swiperRoot.swiper.destroy(true, true);
    }
  }

  static toggleReadMore(button) {
    const block = button.closest('.product-showcase__description-block');
    const truncated = block?.querySelector('.product-showcase__description-truncated');
    const full = block?.querySelector('.product-showcase__description-full');
    const moreLabel = button.querySelector('.product-showcase__read-more-more');
    const lessLabel = button.querySelector('.product-showcase__read-more-less');
    if (!truncated || !full) return;

    const expand = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', expand ? 'true' : 'false');

    if (expand) {
      truncated.setAttribute('hidden', '');
      full.removeAttribute('hidden');
      moreLabel?.setAttribute('hidden', '');
      lessLabel?.removeAttribute('hidden');
    } else {
      full.setAttribute('hidden', '');
      truncated.removeAttribute('hidden');
      lessLabel?.setAttribute('hidden', '');
      moreLabel?.removeAttribute('hidden');
    }
  }
}
customElements.define('product-features-showcase', ProductFeaturesShowcase);

class ProductCarousel extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        const selectorId = this.dataset.selector;
        const swiperConfig = {
            loop: false,
            arrows: false,
            autoplay: false,
            spaceBetween: 30,
            // variableWidth : true,
            breakpoints: {
                320:{
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                572: {
                    slidesPerView: 2,
                    slidesPerGroup: 1
                },
                1080: {
                    slidesPerView: 3,
                    slidesPerGroup: 1
                },
                1300: {
                    slidesPerView: 4,
                    slidesPerGroup: 1
                }
            },
            pagination: {
                el: '.swiper-pagination-'+selectorId,
                type: 'progressbar',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-'+selectorId,
                prevEl: '.swiper-button-prev-'+selectorId,
            }
        }

        new Swiper( '#swiper-'+selectorId, swiperConfig );
    }
}
customElements.define( 'product-carousel',  ProductCarousel );



class ProductVerticalSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const selectorId = this.dataset.selector;
    const swiperSelector = `#swiper-${selectorId}`;
    const paginationSelector = `.swiper-pagination-${selectorId}`;
    const nextBtn = `.swiper-button-next-${selectorId}`;
    const prevBtn = `.swiper-button-prev-${selectorId}`;

    const swiperConfig = {
      loop: true, 
      autoplay: false,
      slidesPerView: 1,
      effect: "fade",
      speed: 500,
      allowTouchMove: false,  
      simulateTouch: false,   
      watchOverflow: true,  
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        320: {
            allowTouchMove: true,  
            simulateTouch: true,   
            watchOverflow: false,  
        },
        768: {
           allowTouchMove: false,  
          simulateTouch: false,   
          watchOverflow: true,  
        },
      },
      pagination: {
        el: paginationSelector,
        clickable: true,
        renderBullet: (index, className) => {
          const swiperInstance = document.querySelector(swiperSelector).swiper;
          if (!swiperInstance) return "";

          if (window.innerWidth >= 767) {
            return `<span class="${className}" data-index="${index}">${index + 1}</span>`; // Normal pagination for larger screens
          }

          let totalSlides = swiperInstance.slides.length;
          let activeIndex = swiperInstance.activeIndex || 0;
          let currentGroup = Math.floor(activeIndex / 1) * 1;
          let output = "";

          if (index >= currentGroup && index < currentGroup + 2) {
            output = `<span class="${className} number ${index === activeIndex ? 'swiper-pagination-bullet-active' : ''}" data-index="${index}">${index + 1}</span>`;
          } else if (index === currentGroup + 2 && index < totalSlides) {
            output = `<span class="${className} dots" data-index="${index}">...</span>`;
          }

          return output;
        },
      },
      on: {
        init: function () {
          this.pagination.render();
          updateActivePagination(this);
        },
        slideChange: function () {
          this.pagination.render();
          updateActivePagination(this);
        },
      },
    };

    const swiperInstance = new Swiper(swiperSelector, swiperConfig);

    // **Ensure Active Pagination Updates Correctly**
    function updateActivePagination(swiper) {
      const bullets = document.querySelectorAll(`${paginationSelector} .swiper-pagination-bullet`);
      bullets.forEach((bullet, index) => {
        bullet.classList.toggle("swiper-pagination-bullet-active", index === swiper.activeIndex);
      });
    }

    // **Click Event: Handle Pagination Clicks**
    this.addEventListener("click", function (e) {
      if (e.target.classList.contains("number")) {
        let slideIndex = parseInt(e.target.getAttribute("data-index"));
        if (!isNaN(slideIndex)) {
          swiperInstance.slideTo(slideIndex);
        }
      } else if (e.target.classList.contains("dots")) {
        let nextIndex = parseInt(e.target.getAttribute("data-index"));
        if (!isNaN(nextIndex)) {
          swiperInstance.slideTo(nextIndex);
        }
      }
    });
  }
}

customElements.define("product-vertical-slider", ProductVerticalSlider);







class ProductImagetextSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const selectorId = this.dataset.selector;

    const swiperConfig = {
      loop: false,
      autoplay: false,
      effect: "fade",
      speed: 500,
      allowTouchMove: false,  
      simulateTouch: false, 
      watchOverflow: true,
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
       breakpoints: {
        320: {
            allowTouchMove: true,  
            simulateTouch: true,   
            watchOverflow: false,  
        },
        768: {
           allowTouchMove: false,  
          simulateTouch: false,   
          watchOverflow: true,  
        },
      },
      pagination: {
        el: ".swiper-pagination-" + selectorId,
        clickable: true,
        renderBullet: (index, className) => {
          const swiperInstance = document.querySelector("#swiper-" + selectorId).swiper;
          if (!swiperInstance) return "";

          if (window.innerWidth >= 767) {
            return `<span class="${className}" data-index="${index}">${index + 1}</span>`;
          }

          let totalSlides = swiperInstance.slides.length;
          let activeIndex = swiperInstance.activeIndex || 0;
          let currentGroup = Math.floor(activeIndex / 1) * 1;
          let output = "";

          if (index >= currentGroup && index < currentGroup + 2) {
            output = `<span class="${className} number ${index === activeIndex ? 'swiper-pagination-bullet-active' : ''}" data-index="${index}">${index + 1}</span>`;
          } else if (index === currentGroup + 2 && index < totalSlides) {
            output = `<span class="${className} dots" data-index="${index}">...</span>`;
          }

          return output;
        },
      },
      navigation: {
        nextEl: ".swiper-button-next-" + selectorId,
        prevEl: ".swiper-button-prev-" + selectorId,
      },
      on: {
        init: function () {
          this.pagination.render();
          updateActivePagination(this);
        },
        slideChange: function () {
          this.pagination.render();
          updateActivePagination(this);
        },
      },
    };

    const swiperInstance = new Swiper("#swiper-" + selectorId, swiperConfig);

    function updateActivePagination(swiper) {
      const bullets = document.querySelectorAll(`.swiper-pagination-${selectorId} .swiper-pagination-bullet`);
      bullets.forEach((bullet, index) => {
        bullet.classList.toggle("swiper-pagination-bullet-active", index === swiper.activeIndex);
      });
    }

    this.addEventListener("click", function (e) {
      if (e.target.classList.contains("number")) {
        let slideIndex = parseInt(e.target.getAttribute("data-index"));
        if (!isNaN(slideIndex)) {
          swiperInstance.slideTo(slideIndex);
        }
      } else if (e.target.classList.contains("dots")) {
        let nextIndex = parseInt(e.target.getAttribute("data-index"));
        if (!isNaN(nextIndex)) {
          swiperInstance.slideTo(nextIndex);
        }
      }
    });
  }
}

customElements.define("product-imagetext-slider", ProductImagetextSlider);



class ProductMedia extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        const id = this.dataset.selector;
        var swiperThumb = new Swiper( '#product-thumb__'+id, {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 5,
            direction: 'vertical',
            watchSlidesProgress: true,
            breakpoints: {
                320: {
                  'direction': "horizontal"
                },
                769: {
                    'direction': "horizontal"
                }
            },
        });

        new Swiper( '#product-media__'+id, {
            loop: true,
            navigation: {
                nextEl: ".swiper-"+id,
                prevEl: ".swiper-"+id,
            },
            thumbs: {
              swiper: swiperThumb,
            },
        });
    }
}
customElements.define( 'product-media', ProductMedia );

class StickyAtcart extends HTMLElement{
    constructor(){
        super();
    }

    /* Panacea 14-10: op mobiel staat de sticky knop er zodra de gewone
       koopknop niet in beeld is, dus ook meteen bij binnenkomst (de knop staat
       dan nog onder de vouw). Op desktop blijft het oude gedrag: pas na 1000px
       scrollen. Bij de footer verdwijnt hij. */
    connectedCallback(){
        const stickySelector = document.querySelector('[data-selector="sticky"]');
        if (!stickySelector) return;
        const mainButton = document.querySelector('product-info product-form [type="submit"]');
        const footer = document.getElementById('footer');
        const mobile = window.matchMedia('(max-width: 749px)');
        let mainVisible = false;
        let footerVisible = false;

        const update = () => {
            let show;
            if (mobile.matches && mainButton) {
                show = !mainVisible && !footerVisible;
            } else {
                show = window.scrollY > 1000 && !footerVisible;
            }
            stickySelector.classList.toggle('active', show);
        };

        if ('IntersectionObserver' in window) {
            if (mainButton) {
                new IntersectionObserver((entries) => { mainVisible = entries[0].isIntersecting; update(); }).observe(mainButton);
            }
            if (footer) {
                new IntersectionObserver((entries) => { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
            }
        } else if (footer) {
            window.addEventListener('scroll', () => { footerVisible = this.isElementInViewport(footer); });
        }
        window.addEventListener('scroll', update, { passive: true });
        update();
    }

    isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
}
customElements.define( 'sticky-atcart', StickyAtcart );

class ProductBlock extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        const title = this.querySelector('[data-block-title]');
        const content = this.querySelector('[data-block-content]');
        title?.addEventListener('click', function(){
            title.classList.toggle('active');
            content.classList.toggle('hidden');
        });
    }
}
customElements.define( 'product-block', ProductBlock );

class ImageHotspot extends HTMLElement{
    constructor(){
        super();
    }
    connectedCallback(){
        const hotspot = this.querySelector('[data-hotspot]');
        this.querySelector('[data-toggle]')?.addEventListener('click', function(){
            return false;
            [...document.querySelectorAll('[data-hotspot]')].map( x => x.classList.add('hidden'));
            hotspot.classList.toggle('hidden');
        })

        this.querySelector('[data-hotspot-close]')?.addEventListener('click', function(){
            return false;
            hotspot.classList.add('hidden');
        })
    }
}
customElements.define('image-hotspot', ImageHotspot);

class ImageHeatmap extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        this.querySelectorAll('.wavelength')?.forEach( (element) => {
            let wavelength = element.dataset.wavelength;
            element.addEventListener( 'click', function(){
                [...document.querySelectorAll('.wavelength')].map( x=> x.classList.remove('active') )
                element.classList.add('active');
                console.log(wavelength);

                [...document.querySelectorAll('.heatmap-inner')].map( x => x.classList.add('hidden') );
                document.querySelector('.heatmap-'+wavelength).classList.remove('hidden');
                
                document.querySelector('.heatmap-'+wavelength).querySelector('[data-wavelength="'+wavelength+'"]').classList.add('active');
            });
        });
    }
}
customElements.define('image-heatmap', ImageHeatmap);

class ProductFeaturesSlider extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        const selectorId = this.dataset.selector;
        const swiperConfig = {
                loop: false,
                arrows: false,
                autoplay: false,
                autoHeight: true,
                spaceBetween: 30,
                slidesPerView: 3,
                variableWidth : true,
                'breakpoints': {
                    320:{
                        'slidesPerView': 1,
                        'slidesPerGroup': 1
                    },
                    768: {
                        'slidesPerView': 2,
                        'slidesPerGroup': 1
                    },
                    1460: {
                        'slidesPerView': 3,
                        'slidesPerGroup': 1
                    }
                },
                pagination: {
                    el: '.swiper-pagination-'+selectorId,
                    type: 'progressbar',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next-'+selectorId,
				    prevEl: '.swiper-button-prev-'+selectorId,
                }
            }

        new Swiper( '#swiper-'+selectorId, swiperConfig );
    }
}
customElements.define('product-features-slider', ProductFeaturesSlider);


class CustomProductSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const selectorId = this.dataset.selector;
        const swiperElement = document.querySelector('#swiper-' + selectorId);
        
        if (!swiperElement) {
            console.error('Swiper container not found for selector:', selectorId);
            return;
        }

        const slideCount = parseInt(this.dataset.slideCount || '0', 10);
        const equalWidth = this.dataset.equalWidth === 'true';

        let swiperConfig = {
            loop: false,
            arrows: false,
            autoplay: false,
            autoHeight: true,
            slidesPerView: 3,
            variableWidth: true,
            breakpoints: {
                320: { slidesPerView: 1.2, slidesPerGroup: 1, spaceBetween: 12 },
                768: { slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 20 },
                992: { slidesPerView: 3, slidesPerGroup: 1 },
            },
            pagination: {
                el: '.swiper-pagination-' + selectorId,
                type: 'progressbar',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next-' + selectorId,
                prevEl: '.swiper-button-prev-' + selectorId
            }
        };

        if (equalWidth && slideCount === 2) {
            swiperConfig.variableWidth = false;
            swiperConfig.slidesPerView = 2;
            swiperConfig.breakpoints = {
                320: { slidesPerView: 1.2, slidesPerGroup: 1, spaceBetween: 12, variableWidth: true },
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                    variableWidth: false,
                },
                992: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    spaceBetween: 20,
                    variableWidth: false,
                },
            };
        }

        new Swiper(swiperElement, swiperConfig);
    }
}

customElements.define('custom-product-slider', CustomProductSlider);


document.querySelectorAll('.cust_compare_atc').forEach(button => {
  button.addEventListener('click', function(event) {
    event.preventDefault();
    
    const elem = this.querySelector(".spinnerOverlay");
    if (elem) {
      elem.style.display = "flex";
    }
    this.classList.add('loading');
    const variantId = this.getAttribute('variant-id');
    if (variantId) {
      addToCart(variantId);
    }
    setTimeout(function() {
     button.classList.remove('loading');
    }, 3000);
  });
});


function addToCart(variantId, quantity = 1) {
  const formData = {
    'items': [{
      'id': variantId,
      'quantity': quantity
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
    }).then((data) => {
      updateCartDrawer(data);
    });
}


$(document).on('click','.bundle_related_products_outer button.add-to-carts',function(){
      var array = [];
      var mainid = $('.product__info-wrapper.grid__item input.product-variant-id').attr('value');
      var qty = $('.template-product-perfect-skin .product-form__input.product-form__quantity input.quantity__input').val();
      array.push({id:mainid,quantity:qty});
      $('.bundle-products .bundle-product').each(function(){
      var idd = $(this).attr('data-id');
      array.push({id:idd,quantity:qty});
      });
      console.log(array);
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          items:array
      },
        dataType: 'json', 
       success: function (data) { 
       console.log('sucess');
       updateCartDrawer(data.items[0]);
       } 
       });
});



async function updateCartDrawer()
{
  document.querySelector("#freegifts-main-popup-container")?.remove();
  const url = window.Shopify.routes.root + 'cart?section_id=cart-drawer';
  const response = await fetch(url);
  const responseText = await response.text();
  const newHtml = new DOMParser().parseFromString(responseText, "text/html").querySelector("cart-drawer").innerHTML;

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
      cartDrawer.innerHTML = newHtml;
      cartDrawer.classList.remove("is-empty");
      cartDrawer.classList.add("animate", "active");
  }

  Array.from(document.getElementsByClassName("spinnerOverlay")).forEach(element => {
    element.style.display = "none";
  });
}

$(document).on('click','.section-image__hotspots .image-hotspots .hotspot .icon-trigger',function(){
var html = $(this).parents('image-hotspot.hotspot').find('.hotspot-content').html();
$(this).parents('.image-hotspots').find('.dawn_theme').html(html);
});

$(document).on('click','.dawn_theme.hotspot-content button.close-hotspot',function(){
var html = $(this).parents('.dawn_theme.hotspot-content').html('');
});



document.addEventListener("DOMContentLoaded", function () {
  /* Panacea 14-10: de knop .add-to-cart bestaat niet meer op elke pagina;
     zonder deze controle gaf dit een JavaScript-fout op bijna elke pagina. */
  const bundleButton = document.querySelector(".add-to-cart");
  if (!bundleButton) return;
  bundleButton.addEventListener("click", function () {
    let mainProductId = this.getAttribute("data-main-product");
    let relatedProducts = this.getAttribute("data-related-products").split(",");

    let productIds = [{ id: mainProductId, quantity: 1 }];

    relatedProducts.forEach(id => {
      if (id) {
        productIds.push({ id: id, quantity: 1 });
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: productIds })
    })
    .then(response => response.json())
    .then(data => {
      window.location.href = "/cart";
    })
    .catch(error => console.error("Error:", error));
  });
});








/* Panacea 14-10: op mobiel lange tekstblokken inklappen met "Lees meer", en de
   vergelijkingstabel inkorten tot de belangrijkste rijen met "Bekijk alle specificaties". */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  var lang = (document.documentElement.lang || 'nl').slice(0, 2);
  var L = {
    nl: ['Lees meer', 'Lees minder', 'Bekijk alle specificaties', 'Toon minder specificaties'],
    de: ['Mehr lesen', 'Weniger anzeigen', 'Alle Spezifikationen ansehen', 'Weniger Spezifikationen'],
    en: ['Read more', 'Show less', 'View all specifications', 'Show fewer specifications'],
    fr: ['Lire la suite', 'Voir moins', 'Voir toutes les caractéristiques', 'Voir moins'],
    es: ['Leer más', 'Ver menos', 'Ver todas las especificaciones', 'Ver menos'],
    it: ['Leggi di più', 'Mostra meno', 'Vedi tutte le specifiche', 'Mostra meno'],
    da: ['Læs mere', 'Vis mindre', 'Se alle specifikationer', 'Vis færre'],
    sv: ['Läs mer', 'Visa mindre', 'Visa alla specifikationer', 'Visa färre'],
    no: ['Les mer', 'Vis mindre', 'Se alle spesifikasjoner', 'Vis færre'],
    nb: ['Les mer', 'Vis mindre', 'Se alle spesifikasjoner', 'Vis færre'],
    pl: ['Czytaj więcej', 'Pokaż mniej', 'Zobacz wszystkie parametry', 'Pokaż mniej']
  }[lang] || ['Lees meer', 'Lees minder', 'Bekijk alle specificaties', 'Toon minder specificaties'];

  function makeToggle(target, openClass, labelClosed, labelOpen, onToggle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'm-readmore';
    btn.textContent = labelClosed;
    btn.addEventListener('click', function () {
      var open = target.classList.toggle(openClass);
      btn.textContent = open ? labelOpen : labelClosed;
      if (onToggle) onToggle(open);
    });
    return btn;
  }

  function initClamp() {
    document.querySelectorAll('.panacea-hero__richtext, .section-alternate .content-richtext .content').forEach(function (el) {
      if (el.dataset.mClamp) return;
      el.dataset.mClamp = '1';
      if (el.scrollHeight < 220) return;
      el.classList.add('m-clamp');
      el.after(makeToggle(el, 'is-open', L[0], L[1]));
    });
    document.querySelectorAll('.section-product__features-slider .spec-wrapper').forEach(function (el) {
      if (el.dataset.mRows) return;
      el.dataset.mRows = '1';
      el.classList.add('m-rows-collapsed');
      el.after(makeToggle(el, 'm-rows-open', L[2], L[3]));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClamp);
  } else {
    initClamp();
  }
})();
